import {
    useMemo,
} from 'react'

import request from 'app/requests/ActivityRecords.requests'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    ArchiveButton,
    useArchive,
    ArchiveConfirmationDialog,
} from 'app/shared-components/Archive'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useRelationshipsManagementRoutes from 'app/SkyNetRoutes/hooks/useRelationshipsManagementRoutes'
import useLabel from 'app/hooks/useLabel'
import {
    WithId,
} from 'app/types/common.types'

import ActivityRecordForm from '../ActivityRecordForm'
import useGetActivityRecord from '../../hooks/useGetActivityRecord'

const ActivityRecordUpdate = ({
    id,
}: Readonly<WithId<number>>) => {
    const l = useLabel()
    const {
        ActivityRecords: ActivityRecordsRoutes,
    } = useRelationshipsManagementRoutes()
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetActivityRecord(id)

    const archive = useArchive({
        requestParamFn: data?.archived ? request.restore
            : request.archive,
        notificationId: 'ActivityRecordUpdate',
        title: l('ACTIVITY_RECORD'),
        data,
        redirectionAfterSuccess: generateSkyNetLink({
            domainPath: ActivityRecordsRoutes.path,
        }),
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        archive,
        data?.archived,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <ActivityRecordForm
                    requestParam={request.update(id)}
                    data={data}
                    onSuccess={invalidate}
                    onCancel={invalidate}
                    customButtons={customButtons}
                />
                <ArchiveConfirmationDialog
                    title={l('ACTIVITY_RECORD')}
                    openConfirmDialog={archive.openConfirmDialog}
                    handleClose={archive.handleArchiveRestoreConfirm}
                    archived={data?.archived}
                />
            </>
        </StatusHandler>
    )
}

export default ActivityRecordUpdate
